import styled from 'styled-components';

export const FinancingProposalFormsWrapper = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 18px;
  background: ${(props) => props.theme.palette.colors.white};
  padding: 24px;
  border-radius: 8px;
`;

export const FinancingProposalHeader = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  align-items: center;
`;

export const FormSpacing = styled.div.attrs({})`
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
`;

export const FormContent = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: center;
`;
export const InputContent = styled.div.attrs({})`
  width: 108px;
`;

export const CenterLogo = styled.div.attrs({})`
  display: flex;
  justify-content: center;
  margin: 1px 0;

  img {
    width: 200px;
    height: auto;
  }
`;
